import { Route } from 'src/routes/Route'
import { Subroute } from 'src/routes/Subroute'
import { UnlockVerifyCodeRoute } from './UnlockVerifyCodeRoute'
import { UnlockAccountCallRequiredRoute } from './UnlockAccountCallRequiredRoute'

const UnlockAccountSubroute = Subroute(
  UnlockVerifyCodeRoute,
  UnlockAccountCallRequiredRoute,
)
export type UnlockAccountSubroute = Subroute<typeof UnlockAccountSubroute>

export const UnlockAccountRoute = Route({
  path: '/unlock-account/:username',
  init: (username: string, subroute?: UnlockAccountSubroute) => ({
    username,
    subroute,
  }),
  fromPath: ({ username }) => (username ? { username } : undefined),
  subroute: UnlockAccountSubroute,
  hideSidebar: true,
})
export type UnlockAccountRoute = Route<typeof UnlockAccountRoute>
